module.exports = __webpack_require__.p + "cb87e810337015a0455654d46d252b89.jpg";